import { SkipBackIcon } from "ui/pagination/pagination.styles";

import Icons from "assets";

/** Figma skips to either end with a double chevron; MUI's default glyph is a chevron against a bar. */
export const PAGINATION_ITEM_SLOTS = {
  first: SkipBackIcon,
  previous: Icons.ChevronLeft,
  next: Icons.ChevronRight,
  last: Icons.DoubleChevron,
};
